import { GraphLink } from "@features/builder/UpdateMetadata/GraphLinks/types"
import { atomWithImmer } from "jotai-immer"

export const GraphLinksFormAtom = atomWithImmer<GraphLink[]>([])
if (process.env.NODE_ENV !== "production") {
  GraphLinksFormAtom.debugLabel = "GraphLinksFormAtom"
}
